import React, { useEffect, useState } from 'react'
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import AdminLayout from "../layout/AdminLayout";
import { useNavigate, useParams } from 'react-router-dom';
import { useGetProductsDetailsQuery, useUpdateProductMutation } from '../../redux/api/productsApi';
import { PRODUCT_CATEGORIES } from "../../constants/constants";

const UpdateProduct = () => {

    const navigate = useNavigate();
    const params = useParams()
    const [product, setProduct] = useState({
        name: "",
        description: "",
        price: "",
        category: "",
        stock: "",
        seller: "",
        displayLocation: "filter",
        colors: [],
        perPieceEnabled: false,
        perPiecePrice: "",
    });
    const { name, description, price, category, stock, seller, displayLocation, colors, perPieceEnabled, perPiecePrice } = product;
    const [newColor, setNewColor] = useState("");
    const [updateProduct, { isLoading, error, isSuccess }] = useUpdateProductMutation();
    const [variants, setVariants] = useState([]);
    const { data } = useGetProductsDetailsQuery(params?.id)

    useEffect(() => {
        if (data?.product) {
            setProduct({
                name: data?.product?.name,
                description: data?.product?.description,
                price: data?.product?.price,
                category: data?.product?.category,
                stock: data?.product?.stock,
                seller: data?.product?.seller,
                displayLocation: data?.product?.displayLocation || "filter",
                colors: Array.isArray(data?.product?.colors) ? data?.product?.colors : [],
                perPieceEnabled: !!data?.product?.perPieceEnabled,
                perPiecePrice: data?.product?.perPiecePrice ?? "",
            })
            setVariants(Array.isArray(data?.product?.variants) ? data.product.variants.map(v => ({ name: v.name || "", price: v.price ?? "", stock: v.stock ?? "", imageUrl: v.imageUrl || "" })) : [])
        }

        if (error) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            toast.success("Product Updated");
            navigate("/admin/products");
        }
    }, [error, isSuccess, data, navigate]);


    const onChange = (e) => {
        setProduct({ ...product, [e.target.name]: e.target.value });
    };

    const submitHandler = (e) => {
        e.preventDefault();
        const cleanVariants = (variants || [])
            .filter(v => (v?.name || '').trim())
            .map(v => ({ name: v.name.trim(), price: Number(v.price || 0), stock: Number(v.stock || 0), ...(v.imageUrl ? { imageUrl: v.imageUrl } : {}) }));
        updateProduct({ id: params?.id, body: { ...product, colors, ...(cleanVariants.length ? { variants: cleanVariants } : { variants: [] }) } });
    }

    if (isLoading) return <Loader />;

    return (
        <AdminLayout>
            <div className=" container-fluid py-4 pt-0 mt-0 "
                style={{fontFamily: "Quicksand, sans-serif" }}>
                <div className="col-12 col-lg-8 mt-0 mt-lg-0 ">
                    <form className="cart-card shadow-sm rounded-4 bg-body p-4" onSubmit={submitHandler}>
                        <h2 className="mb-4 text-center fw-bold" style={{color: "#e04f6e" }}>Update Product</h2>
                        <div className="mb-3">
                            <label htmlFor="name_field" className="form-label" style={{color: "#e04f6e" }}> Name </label>
                            <input
                                type="text"
                                id="name_field"
                                className="form-control"
                                name="name"
                                value={name}
                                onChange={onChange}
                            />
                        </div>

                        {/* Variants (optional) */}
                        <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <label className="form-label fw-semibold mb-0" style={{ color: "#e04f6e" }}>Variants (optional)</label>
                                <button
                                    type="button"
                                    className="btn btn-sm View-btn"
                                    onClick={() => setVariants([...(variants || []), { name: "", price: "", stock: "" }])}
                                >
                                    + Add Variant
                                </button>
                            </div>
                            {variants?.length > 0 && (
                                <div className="mt-2">
                                    {variants.map((v, idx) => (
                                        <div key={idx} className="row g-2 align-items-center mb-2">
                                            <div className="col-6">
                                                <input
                                                    type="text"
                                                    className="form-control rounded-3"
                                                    placeholder="Variant name (e.g., Pink)"
                                                    value={v.name}
                                                    onChange={(e) => {
                                                        const copy = [...variants];
                                                        copy[idx] = { ...copy[idx], name: e.target.value };
                                                        setVariants(copy);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-4">
                                                <input
                                                    type="number"
                                                    className="form-control rounded-3"
                                                    placeholder="Price"
                                                    min="0"
                                                    step="0.01"
                                                    value={v.price}
                                                    onChange={(e) => {
                                                        const copy = [...variants];
                                                        copy[idx] = { ...copy[idx], price: e.target.value };
                                                        setVariants(copy);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-2">
                                                <input
                                                    type="number"
                                                    className="form-control rounded-3"
                                                    placeholder="Stock"
                                                    min="0"
                                                    step="1"
                                                    value={v.stock}
                                                    onChange={(e) => {
                                                        const copy = [...variants];
                                                        copy[idx] = { ...copy[idx], stock: e.target.value };
                                                        setVariants(copy);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-2 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() => setVariants(variants.filter((_, i) => i !== idx))}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <small className="text-muted">If variants are added, product price will default to the selected variant on the product page.</small>
                        </div>

                        <div className="row">
                            <div className="mb-3 col">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="per_piece_enabled"
                                        checked={!!perPieceEnabled}
                                        onChange={(e) => setProduct({ ...product, perPieceEnabled: e.target.checked })}
                                    />
                                    <label className="form-check-label" htmlFor="per_piece_enabled">Enable per piece</label>
                                </div>
                            </div>
                            <div className="mb-3 col">
                                <label className="form-label" htmlFor="per_piece_price" style={{color: "#e04f6e"}}>Per piece price</label>
                                <input
                                    id="per_piece_price"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    className="form-control"
                                    value={perPiecePrice}
                                    onChange={(e) => setProduct({ ...product, perPiecePrice: e.target.value })}
                                    disabled={!perPieceEnabled}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="description_field" className="form-label" style={{color: "#e04f6e" }}>
                                Description
                            </label>
                            <textarea
                                className="form-control"
                                id="description_field"
                                rows="8"
                                name="description"
                                value={description}
                                onChange={onChange}
                            ></textarea>
                        </div>

                        <div className="row">
                            <div className="mb-3 col">
                                <label htmlFor="price_field" className="form-label" style={{color: "#e04f6e" }}> Price </label>
                                <input
                                    type="text"
                                    id="price_field"
                                    className="form-control"
                                    name="price"
                                    value={price}
                                    onChange={onChange}
                                />
                            </div>

                            <div className="mb-3 col">
                                <label htmlFor="stock_field" className="form-label" style={{color: "#e04f6e" }}> Stock </label>
                                <input
                                    type="number"
                                    id="stock_field"
                                    className="form-control"
                                    name="stock"
                                    value={stock}
                                    onChange={onChange}
                                />
                            </div>
                        </div>

                        {/* Display Location */}
                        <div className="mb-3">
                            <label htmlFor="display_location_field" className="form-label" style={{color: "#e04f6e" }}> Display Location </label>
                            <select
                                className="form-select"
                                id="display_location_field"
                                name="displayLocation"
                                value={displayLocation}
                                onChange={onChange}
                            >
                                <option value="homepage">Homepage</option>
                                <option value="filter">Filter Page</option>
                                <option value="both">Both</option>
                            </select>
                        </div>
                        <div className="row">

                            <div className="mb-3 col">
                                <label htmlFor="category_field" className="form-label" style={{color: "#e04f6e" }}> Category </label>
                                <select
                                    className="form-select"
                                    id="category_field"
                                    name="category"
                                    value={category}
                                    onChange={onChange}
                                    required
                                >
                                    <option value=""></option>
                                    {PRODUCT_CATEGORIES.map((cat) => (
                                        <option key={cat} value={cat}>
                                            {cat}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Available Colors */}
                            <div className="mb-3 col-12">
                                <label className="form-label" style={{color: "#e04f6e" }}>Available Colors</label>
                                <div className="d-flex gap-2 mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g. Pink or #F9AFC0"
                                        value={newColor}
                                        onChange={(e) => setNewColor(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="btn View-btn fw-semibold"
                                        onClick={() => {
                                            const c = (newColor || '').trim();
                                            if (!c) return;
                                            if (colors.find((x) => x.toLowerCase() === c.toLowerCase())) return;
                                            setProduct({ ...product, colors: [...colors, c] });
                                            setNewColor("");
                                        }}
                                    >
                                        Add Color
                                    </button>
                                </div>
                                {colors?.length > 0 && (
                                    <div className="d-flex flex-wrap gap-2">
                                        {colors.map((c, i) => (
                                            <div key={i} className="color-chip d-inline-flex align-items-center px-2 py-1 rounded-pill border">
                                                <span className="color-swatch me-2" style={{ backgroundColor: c }}></span>
                                                <span className="small me-2">{c}</span>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-danger py-0 px-2"
                                                    onClick={() => setProduct({ ...product, colors: colors.filter((_, idx) => idx !== i) })}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="mb-3 col">
                                <label htmlFor="seller_field" className="form-label" style={{color: "#e04f6e" }}> Seller Name </label>
                                <input
                                    type="text"
                                    id="seller_field"
                                    className="form-control"
                                    name="seller"
                                    value={seller}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        
                        <button type="submit" className="btn w-100 py-2 fw-semibold View-btn" disabled={isLoading}>
                            {isLoading ? "Updating..." : "UPDATE"}
                        </button>
                    </form>
                </div>
            </div>
        </AdminLayout>
    )
}

export default UpdateProduct
